export const ChartConstants = Object.freeze({
	animationDuration: 2730,
	columnBorderRadius: "4px",
	fontColorGrau: "#84898C",
	fontColorSchwarz: "#2F3435",
	fontSizeKlein: "12px",
	fontSizeMittel: "14px",
})
